import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

const teamMemberAPI = createApi({
    reducerPath: "TeamMemberAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getTeamMemberList: builder.mutation({
            query: (teamMemberQuery) => ({
                url: '/TeamMembers/GetTeamMemberList',
                method: 'POST',
                body: transformRequest(teamMemberQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addEditTeamMembers: builder.mutation({
            query: (Details) => ({
                url: '/TeamMembers/AddEditTeamMembers',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getTeamsMembersById: builder.query({
            query: (teamMemberId) => ({
                url: encryptQueryString(`/TeamMembers/GetTeamsMembersById/?teamMemberId=${Number(teamMemberId)}`),
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteTeamsMemberById: builder.mutation({
            query: (id) => ({
                url: `/TeamMembers/DeleteTeamsMemberById/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllUserByTeamID: builder.query({
            query: (id) => ({
                url: `TeamMembers/GetUnAssignedUserListByTeamId?TeamId=${id}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getUnassignedTeamMembers: builder.query({
            query: (data) => ({
                url: `TeamMembers/GetUnassignedTeamMembers?TeamId=${data.teamId}&PlanningId=${data.planningId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAssignedTeamMembers: builder.mutation({
            query: (data) => ({
                url: `/TeamMembers/GetAssignedTeamMembers`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        assignedTeamMember: builder.mutation({
            query: (data) => ({
                url: `/TeamMembers/AssignedTeamMember`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        unassignedTeamMembers: builder.mutation({
            query: (data) => ({
                url: `/TeamMembers/UnassignedTeamMember?TeamId=${data.teamId}&PlanningId=${data.planningId}&UserId=${data.userId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
})

export const {
    useGetTeamMemberListMutation,
    useAddEditTeamMembersMutation,
    useLazyGetAllUserByTeamIDQuery,
    useDeleteTeamsMemberByIdMutation,
    useLazyGetAllTeamQuery,
    useLazyGetUnassignedTeamMembersQuery,
    useGetAssignedTeamMembersMutation,
    useAssignedTeamMemberMutation,
    useUnassignedTeamMembersMutation,
} = teamMemberAPI;
export default teamMemberAPI;